export default __webpack_public_path__ + "static/media/PP.7682f448.svg";